import React from "react"

/**
 * Get a version of the given component with some props overwritten.
 * @param {(props: object) => JSX.Element} Component
 * @param {object|(props:object) => object} override
 * @returns {JSX.Element}
 */
export default (Component, override) => props => {
  props =
    typeof override === "function" ? override(props) : { ...props, ...override }
  return <Component {...props} />
}
